import React from 'react';
import { format } from 'date-fns';
import { Dropdown, Menu } from 'antd';
import { func, object, string } from 'prop-types';

import {
  NavigationWrapper,
  NavigationContainer,
  UserInfo,
  UserInfoTexts,
  UserName,
  UserDate,
  UserInfoPopup,
  Avatar,
  NavigationRight,
  ButtonS,
  BurgerButton,
  SearchWrap,
} from './styled-components';
import SvgIcon from '../svg-icon/';
import { theme } from '../../styles';
import { ROUTES } from '../../routes';
import { getAvatarUrl } from '../../utils';
import {
  Link,
  DropdownContent,
  DropdownItem,
  DropdownList,
  HeaderSearchInput,
} from '../ui-helpers';

const UserPopup = onLogout => (
  <Menu style={{ padding: 0 }}>
    <DropdownContent width={200}>
      <DropdownList>
        <DropdownItem>
          <Link href={ROUTES.EDIT_USER_DATA}>Profile settings</Link>
        </DropdownItem>
        <DropdownItem>
          <ButtonS onClick={() => onLogout()}>Log Out</ButtonS>
        </DropdownItem>
      </DropdownList>
    </DropdownContent>
  </Menu>
);

const Navigation = ({
  onLogout,
  onSearch,
  setIsOpenMobile,
  userData,
  inputValue,
  pathname,
}) => (
  <NavigationWrapper>
    <NavigationContainer>
      <BurgerButton onClick={() => setIsOpenMobile(true)}>
        <span>-</span>
        <span>-</span>
        <span>-</span>
      </BurgerButton>

      <SearchWrap>
        {/* TODO: Until search not working fine at all pages we need this ternary operator  */}
        {pathname === '/requests' || pathname === '/contacts'
        || pathname === '/companies' ?
          <HeaderSearchInput
            placeholder="Search by keywords..."
            onChange={onSearch}
            suffix={false}
            prefix={false}
            value={inputValue}
          /> : ''}
      </SearchWrap>

      <NavigationRight>
        <Dropdown overlay={UserPopup(onLogout)} trigger={['click']} placement="bottomRight">
          <UserInfo>
            <UserInfoTexts>
              <UserName>{userData.fullName}</UserName>
              <UserDate>{format(new Date(), 'EEEE, do MMM')}</UserDate>
            </UserInfoTexts>
            <UserInfoPopup>
              <Avatar src={getAvatarUrl(userData.profileImage)} />
            </UserInfoPopup>
            <SvgIcon
              type="arrowDown"
              color={theme.colors.fontSilverLighter}
              hoverColor={theme.colors.fontSilverLighter}
            />
          </UserInfo>
        </Dropdown>
      </NavigationRight>

    </NavigationContainer>
  </NavigationWrapper>
);

Navigation.propTypes = {
  pathname: string.isRequired,
  inputValue: string.isRequired,
  onLogout: func.isRequired,
  onSearch: func.isRequired,
  setIsOpenMobile: func.isRequired,
  userData: object.isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/navigation/index.js